import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fields } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo, useMemo } from "react";
import { CustomField } from "~/components/CustomField";
import { DiscussionsMenuButton } from "~/components/Discussions/DiscussionsMenu/components/DiscussionsMenuButton";
import { DiscussionsMenu } from "~/components/Discussions/DiscussionsMenu/DiscussionsMenu";
import { ASSET_MODAL_HEADER_FIELDS_BUTTON, DISCUSSIONS_MENU_BTN } from "~/constants/testIDs";
import { AssetModalPanel, useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
export const HeaderBoardAndFieldsInfo = /*#__PURE__*/ memo((param)=>{
    let { canEditCustomFields, fields, showComments, canViewCustomFields, assetLocation } = param;
    const { showPanel } = useAssetModalPanelContext();
    const fieldsToRender = useMemo(()=>{
        if (!fields || !fields.length) return [];
        return fields.reduce((prev, field)=>{
            if (prev.length === 3) return prev;
            if (field.value) return [
                ...prev,
                field.value
            ];
            if (field.values) {
                const toReturn = prev;
                field.values.forEach((value)=>{
                    if (toReturn.length < 3) toReturn.push(value);
                });
                return toReturn;
            }
            return prev;
        }, []);
    }, [
        fields
    ]);
    const otherFieldsLength = useMemo(()=>{
        if (!fields) return;
        let totalCount = 0;
        fields.forEach((field)=>{
            if (field.value) {
                totalCount += 1;
            } else if (field.values) {
                totalCount += field.values.length;
            }
        });
        const numOtherFields = totalCount - fieldsToRender.length;
        return numOtherFields < 0 ? undefined : numOtherFields;
    }, [
        fields,
        fieldsToRender
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-1.5 flex h-8 w-full items-center justify-start pl-6",
        children: [
            assetLocation,
            showComments && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "ml-1.5 mr-0.5 shrink-0 text-center text-14 text-pigeon-100",
                        children: "・"
                    }),
                    /*#__PURE__*/ _jsx(DiscussionsMenu, {
                        trigger: /*#__PURE__*/ _jsx(DiscussionsMenuButton, {
                            "data-testid": DISCUSSIONS_MENU_BTN
                        })
                    })
                ]
            }),
            (canEditCustomFields || fieldsToRender.length > 0 && canViewCustomFields) && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mx-0.5 shrink-0 text-center text-14 text-pigeon-100",
                        children: "・"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        appearance: "ghost",
                        color: "grey",
                        className: "shrink-0 px-1",
                        "data-testid": ASSET_MODAL_HEADER_FIELDS_BUTTON,
                        onClick: ()=>showPanel(AssetModalPanel.FIELDS),
                        prefix: /*#__PURE__*/ _jsx(Fields, {
                            className: "size-4"
                        }),
                        size: "small",
                        children: fieldsToRender.length ? /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-1",
                            children: [
                                fieldsToRender.map((field)=>/*#__PURE__*/ _jsx(CustomField, {
                                        field: field
                                    }, field.id)),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-12 text-grey-10",
                                    children: !!otherFieldsLength && "+".concat(otherFieldsLength)
                                })
                            ]
                        }) : "Add custom field"
                    })
                ]
            })
        ]
    });
});
HeaderBoardAndFieldsInfo.displayName = "HeaderBoardAndFieldsInfo";
